var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1933 4.29289C11.5578 4.68342 11.5578 5.31658 11.1933 5.70711L7.1866 10H17.0667C17.5821 10 18 10.4477 18 11C18 11.5523 17.5821 12 17.0667 12H7.1866L11.1933 16.2929C11.5578 16.6834 11.5578 17.3166 11.1933 17.7071C10.8288 18.0976 10.2379 18.0976 9.87337 17.7071L4.27337 11.7071C3.90888 11.3166 3.90888 10.6834 4.27337 10.2929L9.87337 4.29289C10.2379 3.90237 10.8288 3.90237 11.1933 4.29289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.6ffd661dbccdc23cf660846666ce5e3f.svg";
export { ForwardRef as ReactComponent };